import React from 'react';
import Icon from '../../../components/AppIcon';

const BenefitsPanel = () => {
  const benefits = [
  {
    icon: 'Calendar',
    title: 'Etkinlik Keşfi',
    description: 'Türkiye genelindeki SUP etkinliklerini keşfedin ve katılın'
  },
  {
    icon: 'MapPin',
    title: 'Spot Rehberi',
    description: 'En iyi paddle boarding noktalarını harita üzerinde görüntüleyin'
  },
  {
    icon: 'ShoppingBag',
    title: 'Ekipman Mağazası',
    description: 'Resmi mağazadan kaliteli ekipman satın alın'
  },
  {
    icon: 'Users',
    title: 'Topluluk',
    description: 'SUP tutkunlarıyla tanışın ve deneyimlerinizi paylaşın'
  },
  {
    icon: 'MessageCircle',
    title: 'Mesajlaşma',
    description: 'Organizatörler ve diğer kullanıcılarla iletişime geçin'
  },
  {
    icon: 'Award',
    title: 'Rozetler & Ödüller',
    description: 'Etkinliklere katılarak özel rozetler kazanın'
  }];


  const testimonials = [
  {
    name: 'Ayşe Yılmaz',
    role: 'SUP Eğitmeni',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d32983a9-1763298123533.png",
    avatarAlt: 'Professional headshot of Turkish woman with long brown hair wearing blue athletic wear',
    content: 'PaddleTurkiye sayesinde etkinliklerimi kolayca organize edebiliyorum. Topluluk çok aktif ve destekleyici!'
  },
  {
    name: 'Mehmet Kaya',
    role: 'SUP Tutkunu',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_11b6e1ff5-1763300730912.png",
    avatarAlt: 'Professional headshot of Turkish man with short black hair wearing red sports shirt',
    content: 'Türkiye\'nin en iyi SUP noktalarını bu platform sayesinde keşfettim. Harika bir deneyim!'
  }];


  return (
    <div className="w-full h-full flex flex-col">
      <div className="mb-6 md:mb-8 lg:mb-10">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-semibold mb-2 md:mb-3" style={{ color: 'var(--color-primary)' }}>
          Topluluğa Katılın
        </h2>
        <p className="text-sm md:text-base lg:text-lg" style={{ color: 'var(--color-muted-foreground)' }}>
          Türkiye'nin en büyük SUP topluluğunun bir parçası olun
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 lg:gap-6 mb-6 md:mb-8 lg:mb-10">
        {benefits?.map((benefit, index) =>
        <div
          key={index}
          className="p-4 md:p-5 lg:p-6 rounded-lg md:rounded-xl transition-smooth"
          style={{
            backgroundColor: 'var(--color-card)',
            border: '1px solid var(--color-border)'
          }}>

            <div
            className="w-10 h-10 md:w-12 md:h-12 rounded-lg md:rounded-xl flex items-center justify-center mb-3 md:mb-4"
            style={{
              backgroundColor: 'rgba(27, 75, 102, 0.08)'
            }}>

              <Icon name={benefit?.icon} size={20} color="var(--color-primary)" />
            </div>
            <h3 className="text-base md:text-lg font-semibold mb-1 md:mb-2" style={{ color: 'var(--color-foreground)' }}>
              {benefit?.title}
            </h3>
            <p className="text-xs md:text-sm" style={{ color: 'var(--color-muted-foreground)' }}>
              {benefit?.description}
            </p>
          </div>
        )}
      </div>
      <div className="mt-auto">
        <h3 className="text-lg md:text-xl font-semibold mb-4 md:mb-5 lg:mb-6" style={{ color: 'var(--color-foreground)' }}>
          Kullanıcı Yorumları
        </h3>
        <div className="space-y-4 md:space-y-5 lg:space-y-6">
          {testimonials?.map((testimonial, index) =>
          <div
            key={index}
            className="p-4 md:p-5 lg:p-6 rounded-lg md:rounded-xl"
            style={{
              backgroundColor: 'var(--color-card)',
              border: '1px solid var(--color-border)'
            }}>

              <div className="flex items-start gap-3 md:gap-4 mb-3 md:mb-4">
                <img
                src={testimonial?.avatar}
                alt={testimonial?.avatarAlt}
                className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
                style={{ flexShrink: 0 }} />

                <div className="min-w-0 flex-1">
                  <h4 className="text-sm md:text-base font-semibold" style={{ color: 'var(--color-foreground)' }}>
                    {testimonial?.name}
                  </h4>
                  <p className="text-xs md:text-sm" style={{ color: 'var(--color-muted-foreground)' }}>
                    {testimonial?.role}
                  </p>
                </div>
              </div>
              <p className="text-xs md:text-sm leading-relaxed" style={{ color: 'var(--color-foreground)' }}>
                "{testimonial?.content}"
              </p>
            </div>
          )}
        </div>
      </div>
    </div>);

};

export default BenefitsPanel;